/*eslint-disable */
const $ = window.jQuery = require('jquery');

import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import authorizedUserForDemoRequest from '@/components/private/demoRequests/authorized-user-for-demo-request/';
import {
  bus
} from '@/main';
import carousel from 'vue-owl-carousel';
import createdModels from './created-models-list/index.vue';
import {
mapGetters,
} from 'vuex';
import publicModels from './public-models/index.vue';
import recentlyUsedModels from './recently-used-models/index.vue';
import sharedModels from './shared-models-list/index.vue';
import usedHistoryModelsList from './used-models-history-list/index.vue';

export default {
  name: 'ai-dashboard',
  components: {
    carousel,
    'created-models' : createdModels,
    'public-models' : publicModels,
    'recently-used-Models' : recentlyUsedModels,
    'shared-models-list' : sharedModels,
    'used-history-models-list' : usedHistoryModelsList,
    'access-feature-of-blurb' : accessFeaturesForBlurb,
    'authorized-user-for-demo-request':authorizedUserForDemoRequest,
  },
  props: [],
  data () {
    return {
      countryList:[],
      userFilterInfoPopupState:false,
      userFilterInfoPopupStateClass:false,
      userFilterInfoData:null,
      userDetails:null,
      accessFeaturesOfPackageState:false,
      authorizedUserDemoForReqState:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserDetailsFun(){
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
  },
  mounted () {
    this.getSelfUserDetailsFun
    bus.$on('accessFeaturesOfPackageStateBus', (data) => {
      this.accessFeaturesOfPackageState = data;
    });
    bus.$on('authorizedUserDemoForReqStateBus', (data) => {
      this.authorizedUserDemoForReqState = data
    });
  },
  methods: {
    authorizedUserDemoForReqStatePopup(){
      document.body.classList.add('body_right_scroll_remove');
      this.authorizedUserDemoForReqState =  true
    },
    accessFeaturesOfPackagemethod(){
      this.accessFeaturesOfPackageState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    accessPageMethod(){
      if(this.userDetails){
        if(this.userDetails.pro_payment || this.userDetails.auto_payment){
          this.$router.push({name:'AiModelsCreated'})
        }else{
          this.accessFeaturesOfPackageState = true
          document.body.classList.add('body_right_scroll_remove')
        }
      }
    },
    userFiltersInfoPopupMethod(data){
      this.userFilterInfoData = data
      $(window).scrollTop(0);
      this.userFilterInfoPopupState = true
      document.body.classList.add('body_right_scroll_remove')
      setTimeout(() => {
        this.userFilterInfoPopupStateClass = true
      }, 10);
    },
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false
      setTimeout(() => {
        this.userFilterInfoPopupState = false
        document.body.classList.remove('body_right_scroll_remove')
        this.userFilterInfoData = ''
      }, 600);
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    getSelfUserDetailsFun(){
      return this.$store.getters.acUserDetailsStateGetters;
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("body_right_scroll_remove");
    next();
  },
}